<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>Heartfelt thanks to my wife and partner, Alice, for her encouragement and comradery during the long hours I spent writing <em>Medicine Park.</em> It was comforting to know I was not alone.</p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?ae2bc362